import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';

const {
  APPLY_SELECTED_TEMPLATES_REQUEST_2_0,
  APPLY_SELECTED_TEMPLATES_SUCCESS_2_0,
  APPLY_SELECTED_TEMPLATES_FAILURE_2_0,
  APPLY_SELECTED_TEMPLATES_LOADING_2_0,
  APPLY_SELECTED_TEMPLATES_RESET_2_0,
} = therapyPlanningAction;

function* applySelectedTherapyTemplate(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: APPLY_SELECTED_TEMPLATES_LOADING_2_0 });
    const response = yield call(therapyPlanningService.applyTherapyTemplates, payload?.payload);
    if (response?.status === 200) {
      yield put({
        type: APPLY_SELECTED_TEMPLATES_SUCCESS_2_0,
        payload: response?.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: APPLY_SELECTED_TEMPLATES_FAILURE_2_0, payload: error });
  }
}

function* applySelectedTherapyTemplateSaga() {
  yield takeEvery(APPLY_SELECTED_TEMPLATES_REQUEST_2_0, applySelectedTherapyTemplate);
}

export default applySelectedTherapyTemplateSaga;
